<template>
  <v-container fluid>
    <v-row>
      <!-- name/title card -->
      <v-col>
        <v-card>
          <v-row
            no-gutters
            justify="center"
            align="center"
          >
            <v-col>
              <v-card-title class="headline font-weight-medium">
                Profile
                <v-spacer />
              </v-card-title>
              <v-card-subtitle class="title font-weight-regular">{{ getName }} • {{ getOrg }}</v-card-subtitle>
            </v-col>
            <v-col align="right">
              <v-btn
                icon
                @click="onEditClick()"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <!-- about card -->
        <v-card :loading="loading">
          <v-card-title>
            ABOUT
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="onEditClick()"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-map-marker</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Location</div>
                {{ this.getUserProfile.location }}
              </v-col>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-phone</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Phone</div>
                {{ this.getUserProfile.phone }}
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-email</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Email</div>
                {{ this.getUserProfile.email }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <!-- security card -->
        <v-card :loading="loading">
          <v-card-title>SECURITY</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-lock</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Password Last Updated</div>
                <span v-if="this.getUserProfile.lastPwChange">{{ formatDateTime(this.getUserProfile.lastPwChange) }} • {{ getTimeSince(this.getUserProfile.lastPwChange)}}</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1">
                <v-icon class="pt-2">mdi-account-check</v-icon>
              </v-col>
              <v-col>
                <div class="overline">Permissions</div>
                {{ getPermissionsString(this.getUserProfile) }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="onChangePasswordClick"
              color="primary"
              >CHANGE PASSWORD</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- activity card -->
      <!-- <v-col>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>ACTIVITY</v-card-title>
              <v-card-text>
                <li>01/23/2020 Resolved case 123</li>
                <li>01/24/2020 Added Client Sunnybabo</li>
                <li>04/13/2020 FastSearch Manuel Noreiaga</li>
                <li>01/23/2020 Resolved case 123</li>
                <li>01/23/2020 Updated Password</li>
                <li>01/24/2020 Added Client Sunnybabo</li>
                <li>04/13/2020 FastSearch Manuel Noreiaga</li>
                <li>01/23/2020 Resolved case 123</li>
                <li>01/24/2020 Added Client Sunnybabo</li>
                <li>04/13/2020 FastSearch Manuel Noreiaga</li>
                <li>01/23/2020 Resolved case 123</li>
                <li>01/24/2020 Added Client Sunnybabo</li>
                <li>04/13/2020 FastSearch Manuel Noreiaga</li>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>-->
    </v-row>

    <EditProfile
      :user="this.getUserProfile"
      :loading="modalLoading"
      v-if="isEditDialogVisible"
      :visible="isEditDialogVisible"
      :error="error"
      v-on:onConfirmed="onEditProfileConfirmed"
      v-on:onCancelled="onEditProfileCancelled"
    />

    <ChangePassword
      :loading="modalLoading"
      v-if="isPasswordDialogVisible"
      :visible="isPasswordDialogVisible"
      :error="error"
      v-on:onConfirmed="onChangePasswordConfirmed"
      v-on:onCancelled="onChangePasswordCancelled"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EditProfile from "../../modals/EditProfile";
import ChangePassword from "../../modals/ChangePassword";
import { getTimeSince, formatDateTime } from "../../utils/dateUtils";
export default {
  name: "Profile",
  components: { EditProfile, ChangePassword },
  data() {
    return {
      loading: true,
      isEditDialogVisible: false,
      isPasswordDialogVisible: false,
      modalLoading: false,
      error: "",
    };
  },
  methods: {
    ...mapActions(["editProfile", "changePassword", "setGlobalAlert"]),
    getTimeSince,
    formatDateTime,
    // Open edit
    onEditClick: function () {
      this.isEditDialogVisible = true;
    },
    // Save edit
    async onEditProfileConfirmed(user) {
      this.modalLoading = true;
      try {
        await this.editProfile(user);
        this.isEditDialogVisible = false;
        this.setGlobalAlert({
          alert: true,
          color: "green",
          alertTitle: "Your user profile has been updated.",
        });
      } catch (e) {
        console.log("and error", e);
        this.error = this.$t("error.general.unhandled");
      }
      this.modalLoading = false;
    },
    // Cancel edit
    onEditProfileCancelled() {
      this.isEditDialogVisible = false;
      this.error = null;
    },
    // Password update
    onChangePasswordClick: function () {
      this.isPasswordDialogVisible = true;
    },
    // Save edit
    async onChangePasswordConfirmed(password) {
      this.modalLoading = true;

      this.changePassword(password)
        .then(() => {
          this.isPasswordDialogVisible = false;
          this.setGlobalAlert({
            alert: true,
            color: "green",
            alertTitle: "Your password has been updated.",
          });
        })
        .catch(() => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: this.$t("error.general.unhandled"),
          });
        })
        .finally(() => {
          this.modalLoading = false;
        });
    },
    // Cancel edit
    onChangePasswordCancelled() {
      this.isPasswordDialogVisible = false;
      this.error = null;
    },
    getPermissionsString(user) {
      if (user.admin) {
        return "Application Administrator";
      } else {
        return user.permissions == null || user.permissions === undefined || user.permissions.length == 0
          ? ""
          : Array.prototype.map
              .call(user.permissions, function (item) {
                return item.name;
              })
              .join(", ");
      }
    },
  },
  computed: {
    ...mapGetters(["getUserProfile", "getOrg", "getName"]),
  },
  props: {},
  created() {
    this.loading = false;
  },
};
</script>

<style></style>
